import { UseBaseQueryOptions } from "@tanstack/react-query";
import axios from "axios";
import { store } from "../core/store/ConfigStore";

export const GetCustomerFeature = async (params: UseBaseQueryOptions) => {
  const customerId = params.queryKey && params.queryKey[1];
  const token = store.getState().Auth.Token;
  const config = {
    Authorization: `Bearer ${token}`,
    "Content-type": "application/json",
  };
  const { data } = await axios.get(
    `${process.env.REACT_APP_URL}/Setting/CustomFeature/Customer/Portal/${customerId}`,
    { headers: config }
  );
  return data;
};
